
  import { Component, Prop, Watch } from 'vue-property-decorator'
  import { ContentBase } from '@/components/forms/inspection/steppers/content/ContentBase'
  import GFormSlot from '@/components/forms/GFormSlot.vue'
  import GFiles from '@/components/core/files/GFiles.vue'
  import { sortArray } from '@/utils/array/manipulation'
  import { isArray } from 'class-validator'
  import { Debounce } from '@/utils/decorators'
  import { Component as CategoryComponent } from '@/entities/vehicle'
  import GCostField from '@/components/core/input/GCostField.vue'

@Component({
  components: { GCostField, GFiles, GFormSlot },
  methods: {
    sortArray,
  },
})
  export default class ScannerContent extends ContentBase {
  @Prop({ type: Object }) scanner: CategoryComponent
  items = []
  fieldsKeys = ['noise', 'status']
  loadingSend = false

  formData = {
    noise: {
      answer: null,
      provisional: null,
      comment: undefined,
    },
    status: {
      answer: null,
      provisional: null,
    },
    cost: undefined,
    photo: null,
  }

  errorIdentifierMessage = {
    noise: {
      status: '',
    },
    status: {
      status: '',
      provisional: '',
    },
    emissions: {
      status: '',
      provisional: '',
    },
  }

  loadingFile (flag) {
    this.isUploadingFile = flag
  }

  async send () {
    const { formData: data } = this
    if (this.validateFields(data)) {
      return
    }
    this.loadingSend = true
    const { idProcess, idEmployee, inspection, scanner: component, photoProperties, idProcessInspection } = this
    let resp

    const statusData = data?.status?.provisional ? [data.status.provisional] : data.status.answer || []
    const matchingInspectedComponent = inspection.inspectedComponents.find(
      ic => ic.inspectionComponent.id === component?.inspectionComponent?.id
    )

    if (matchingInspectedComponent) {
      resp = matchingInspectedComponent
      await this.edit(resp, data.cost, { noiseData: data.noise, statusData }, component)
    } else {
      const fields = {
        id_inspection: inspection.id,
        id_inspection_component: component.inspectionComponent.id,
        id_process: idProcessInspection,
        cost: data?.cost,
        comment: data?.noise?.comment,
        inspection_qualifications: {
          data: [
            {
              id_employee: idEmployee,
              id_inspection_parameter: component?.findQuestion(1)?.id,
              id_inspection_assessment: data.noise.answer,
            },
            ...statusData.map(status => {
              return {
                id_employee: idEmployee,
                id_inspection_parameter: component?.findQuestion(2)?.id,
                id_inspection_assessment: status,
              }
            }),
          ].filter(_ => _?.id_inspection_assessment),
        },
      }

      resp = await this.pushData({ model: 'InspectionInspectedComponent', fields })
    }

    await this.addFiles(data.photo, photoProperties, idProcess, resp)
    this.$emit('next')
    this.$emit('input', { cost: this.formData.cost || 0 })
    this.$emit('update:inspection')
    this.loadingSend = false
  }

  @Watch('formData', { immediate: true, deep: true })
  @Debounce(100)
  onFormDataChange (val) {
    this.initiateErrorMessage()
    const { scanner, fieldsKeys, validation } = this
    if (validation) {
      this.validation = false
      return
    }
    this.cost = this.isAnyFieldValid(fieldsKeys, val, scanner)

    if (!this.cost && val.cost) {
      this.formData.cost = 0
    }
  }

  initiateErrorMessage () {
    this.errorIdentifierMessage.status.status = ''
    this.errorIdentifierMessage.status.provisional = ''
    this.errorIdentifierMessage.noise.status = ''
  }

  setErrorMessage (field) {
    if (this.formData[field]?.provisional === null || this.formData[field]?.provisional === undefined) {
      this.errorIdentifierMessage[field].provisional = 'Este campo es requerido'
    } else if (this.formData[field]?.provisional !== null || this.formData[field]?.provisional !== undefined) {
      this.errorIdentifierMessage[field].provisional = ''
    }

    this.errorIdentifierMessage[field].status = 'Este campo es requerido'
  }

  handleValidation (field, data) {
    const isArr = isArray(data[field]?.answer)
    const isNum = !isNaN(data[field]?.answer)

    if ((isNum && !data[field]?.answer) || (isArr && !data[field]?.answer.length)) {
      this.setErrorMessage(field)
      return true
    }
    this.errorIdentifierMessage[field].status = ''
    return false
  }

  validateFields (data) {
    const fields = ['noise', 'status']
    let isValid = false
    const { displayField } = this

    for (const field of fields) {
      if (field === 'status' && !displayField) return false
      const isProvisional = 'provisional' in data[field]
      const validNotProvisional = isProvisional === false && this.handleValidation(field, data)
      const validProvisional = (isProvisional === true && !data[field]?.provisional) && this.handleValidation(field, data)

      if (data[field]?.provisional) {
        this.validation = true

        if (this.formData?.[field]?.answer) {
          this.formData[field].answer = []
        }
      }

      if (validNotProvisional || validProvisional) {
        isValid = true
        break
      } else {
        this.errorIdentifierMessage[field].status = ''
      }
    }

    return isValid
  }

  @Watch('scanner', { immediate: true, deep: true })
  @Debounce(100)
  async onComponentsChange (val) {
    const { idProcess, inspection, displayQualification } = this

    const matchingInspectedComponent = inspection.inspectedComponents.find(
      ic => ic.inspectionComponent.id === val?.inspectionComponent?.id
    )

    if (matchingInspectedComponent) {
      this.formData.photo = await this.fetchData({
        query: { name: 'find', model: 'FileProcess' },
        filter: {
          _and: [
            { id_process_record: { _eq: matchingInspectedComponent.id } },
            { parameter: { process: { id: { _eq: idProcess } } } },
            { parameter: { file_type: { name: { _eq: 'photo' } } } },
          ],
        },
        force: true,
      })

      this.formData.noise.answer = matchingInspectedComponent?.findInspectionQualificationByOrder(1)?.[0]?.assessment?.id
      this.processFormData('status', 2, matchingInspectedComponent)
      this.formData.noise.comment = matchingInspectedComponent.comment
      this.formData.cost = matchingInspectedComponent.cost

      if (matchingInspectedComponent.cost) {
        this.cost = true
      }
    }

    if (this.formData.noise.answer && !displayQualification) {
      this.$emit('next')
    }
    this.$emit('input', { cost: this.formData.cost || 0 })
  }

  processFormData (field, order, component) {
    const param = component.findInspectionParameterByOrder(order)
    const qual = component.findInspectionQualificationByOrder(order)

    if (!param?.assessment?.score) {
      this.formData[field].provisional = param?.assessment?.id
      this.formData[field].answer = null
    } else {
      this.formData[field].provisional = false
      this.formData[field].answer = qual.map(item => item.assessment.id)
    }
  }

  async edit (component, cost, data, scanner) {
    const { noiseData, statusData } = data
    const { idEmployee } = this

    const isParameter = component.findInspectionQualificationByOrder(2)?.[0]?.parameter?.id

    if (isParameter) {
      await this.editMultipleComponent(component, statusData, idEmployee, 2)
    } else {
      await Promise.all(statusData.map(async status => {
        const fields = {
          id_employee: idEmployee,
          id_inspection_parameter: scanner?.findQuestion(2)?.id,
          id_inspection_assessment: status,
          id_inspection_inspected_component: component.id,
        }
        await this.pushData({
          model: 'InspectionQualification',
          fields,
        })
      }))
    }

    const parameter = component.findInspectionParameterByOrder(1)
    if (parameter.assessment.id !== noiseData.answer) {
      const fields = {
        id: parameter.id,
        id_inspection_assessment: noiseData.answer,
      }
      await this.pushData({ model: 'InspectionQualification', fields })
    }

    await this.pushData({
      model: 'InspectionInspectedComponent',
      fields: { id: component.id, cost, comment: noiseData?.comment },
    })
  }

  get displayField () {
    const { formData, scanner } = this
    if (!scanner) return false

    const isDisplayField = formData.noise.answer === this.getQuestionOptionScoreZero(scanner, 1)[0].id

    if (isDisplayField) {
      this.formData.noise.comment = undefined
    }
    return isDisplayField
  }

  @Watch('formData.noise.answer', { immediate: true })
  onNoiseChange (val) {
    if (val && this.getQuestionOptionsScoreNotZero(this.scanner, 1)[0].id === val) {
      this.formData.status.answer = []
      this.formData.status.provisional = this.getQuestionOptionScoreZero(this.scanner, 2)[0].id
    }
  }

  get displayComment () {
    const { formData: { noise }, scanner, getQuestionOptionsScoreNotZero } = this

    return noise.answer === getQuestionOptionsScoreNotZero(scanner, 1)?.[0].id
  }

  get requiredPhoto () {
    const { formData: { noise }, scanner, getQuestionOptionScoreZero } = this

    return noise.answer === getQuestionOptionScoreZero(scanner, 1)?.[0].id
  }
  }
